import React from 'react';
import DefaultJideEnvContent from '../DefaultJideEnvContent';

import './jide_env_default.css';

const JideEnvDefault = () => <DefaultJideEnvContent />;

export default JideEnvDefault;
